<template>
  <div class="rightTableDiv">
    <div style="height: 100%;">
      <search-form
        ref="searchForm"
        @showEquipmentHeadManage="showEquipmentHeadManage"
        @setSearchCondition="setSearchCondition"
        @clearSearch="clearSearch"
        @openDrawer="openDrawer"
        @derive="derive"
        @handleImport="handleImport"
        @changeScrollY="changeScrollY"
        @saveAdvanced="saveAdvanced"
        :selectedRows="selectedRows"
        :comid="treeSearchModel.subcompanyid"
        class="searchFormDiv"></search-form>
      <a-table
        :components="components"
        ref="assetTable"
        bordered
        class="assetTable"
        id="assetTable"
        :pagination="false"
        :rowKey="record => record.id"
        :columns="columns"
        :dataSource="tableData.data"
        :loading="tableData.loading"
        @change="handleTableChange"
        :rowSelection="{columnWidth: 40, selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :expanded-row-keys.sync="expandedRowKeys"
        :scroll="{ y: scrollY, x: scrollX }"
        :expandIconColumnIndex="2"
        :expandIcon="expandIcon"
        :customRow="changeRow"
        :indentSize="20"
        :rowClassName="rowClassName"
      >
        <div
          slot="filterDropdown"
          slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
          style="padding: 8px"
        >
          <!--          v-model="headerSearchModel[column.dataIndex]"-->
          <a-date-picker
            v-if="column.isDate"
            :showToday="false"
            format="YYYY-MM-DD"
            :placeholder="`选择搜索${column.title}`"
            v-model="selectedKeys[0]"
            @change="e => setSelectedKeys(e ? [e] : [])"
            style="width: 188px; margin-bottom: 8px; display: block;"
          />
          <a-input
            v-else
            v-ant-ref="c => (searchInput = c)"
            v-model="headerSearchModel['head_' + column.dataIndex]"
            :placeholder="`输入搜索${column.title}`"
            @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
            style="width: 188px; margin-bottom: 8px; display: block;"
          />
          <a-button
            type="primary"
            icon="search"
            size="small"
            style="width: 90px; margin-right: 8px"
            @click="handleSearch(selectedKeys,confirm, column)"
          >
            查询
          </a-button>
          <a-button size="small" style="width: 90px" @click="handleReset(clearFilters, column)">
            重置
          </a-button>
        </div>
        <a-icon
          slot="filterIcon"
          slot-scope="filtered, column"
          type="search"
          :style="{ color: headerSearchModel['head_' + column.dataIndex] ? '#108ee9' : undefined }"
        />
        <template slot="relevantdeptname" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">{{ record.relevantdeptname }}</template>
            <span class="assetNameTable">{{ record.relevantdeptname }}</span>
          </a-tooltip>
        </template>
        <!--      使用部门-->
        <template slot="usedeptname" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">{{ record.usedeptname }}</template>
            <span class="assetNameTable">{{ record.usedeptname }}</span>
          </a-tooltip>
        </template>
        <!--      部门使用人-->
        <template slot="principalName" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">{{ record.principalName }}</template>
            <span class="assetNameTable">{{ record.principalName }}</span>
          </a-tooltip>
        </template>
        <!--      规格型号-->
        <template slot="specification" slot-scope="text, record">
          <a-tooltip>
            <template slot="title">{{ record.specification }}</template>
            <span class="assetNameTable">{{ record.specification }}</span>
          </a-tooltip>
        </template>
        <!--      设备状态-->
        <template slot="equipmentStatusName" slot-scope="text, record">
          <span class="blueIcon padding-1-8">{{ record.equipmentStatusName }}</span>
        </template>
        <!--      特性-->
        <template slot="peculiarity" slot-scope="text, record">
          <a-tooltip placement="top" v-if="record.isYlrqPeculiarity">
            <template slot="title">压力容器</template>
            <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #08409F80; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #08409FFF">压</span>
          </a-tooltip>
          <a-tooltip placement="top" v-if="record.isTzsbPeculiarity">
            <template slot="title">特种设备</template>
            <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #E73B3B80; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #E73B3BFF">特</span>
          </a-tooltip>
          <a-tooltip placement="top" v-if="record.isHbPeculiarity">
            <template slot="title">环保特性</template>
            <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #36BF7D80; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #36BF7DFF">环</span>
          </a-tooltip>
        </template>
        <template slot="actions2" slot-scope="text, record">
          <span>×</span>
        </template>
        <template slot="actions3" slot-scope="text, record">
          <span>×</span>
        </template>
        <template slot="actions4" slot-scope="text, record">
          <span>{{ record.pnode ? '√' : '×' }}</span>
        </template>
        <template slot="actions5" slot-scope="text, record">
          <span>{{ (record.pid === '0' || record.pid === null || record.pid === true) ? '×' : '√' }}</span>
        </template>
        <template slot="actions6" slot-scope="text, record">
          <span class="orgIcon">故</span>
        </template>
        <template slot="actions7" slot-scope="text, record" style="background-color: red;">
          <span class="redIcon">即</span>
        </template>
        <template slot="footer">
          <div class="footerDiv">
            <!--            <div class="footerDivOne">-->
            <!--              <span>合集数量：</span>-->
            <!--              <span>{{ tableData.statistics.normalSum ? tableData.statistics.normalSum : 0 }}</span>-->
            <!--            </div>-->
            <div class="footerDivOne">
              <span class="totalNumDiv">
                <span>设备总数：</span>
                <span>{{ tableData.statistics.sumTotal ? tableData.statistics.sumTotal : 0 }}</span>
              </span>
            </div>
            <div class="footerDivTwo">
              <span class="totalNumDiv">
                <span>虚拟设备总数：</span>
                <span>{{ tableData.statistics.virtualTotal ? tableData.statistics.virtualTotal : 0 }}</span>
              </span>
            </div>
            <div class="footerDivThree">
              <span class="totalNumDiv">
                <span>常规设备总数：</span>
                <span>{{ tableData.statistics.routineTotal ? tableData.statistics.routineTotal : 0 }}</span>
              </span>
            </div>
          </div>
        </template>
      </a-table>
      <div class="dataAndPagin">
        <div class="selectedDataDiv">
          <div class="dataDiv">
            <div class="numDiv">加入到货：100</div>
            <div class="numDiv">加入组合：100</div>
            <div class="numDiv">加入发放：100</div>
          </div>
          <a-button type="primary">+</a-button>
        </div>
        <a-pagination
          v-model="pagination.pageNum"
          :pageSize="pagination.pageSize"
          :total="pagination.total"
          @change="handleTableChange2"
          @showSizeChange="handleTableSize"
          show-less-items
          show-size-changer
          show-quick-jumper
        />
      </div>
      <div style="height: 40%;border: 1px solid #DDDDDD;">
        <data-tabs ref="dataTabs" :model="dataTabsModel"></data-tabs>
      </div>
    </div>
    <div
      class="filtrate"
      id="filtrate"
      v-drag
      v-show="searchNum === 0"
      @dblclick="showSearchModel">
      <span>详细筛选</span>
    </div>
    <div class="filtrateNum" id="filtrateNum" v-drag @dblclick="showSearchModel" v-show="searchNum > 0">
      <span>详细筛选</span>
      <div class="circle">
        <span>{{ searchNum }}</span>
      </div>
    </div>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li v-if="$auth('centralizedManagement.add')" @click="openDrawer2('add')">新增设备</li>
      <!--      <li v-if="$auth('centralizedManagement.add')" @click="openDrawer('add')">新增设备</li>-->
      <li v-if="$auth('centralizedManagement.add') && visibleShow === 'all'" @click="plugInDevice('father')">插入父设备</li>
      <li v-if="$auth('centralizedManagement.add') && visibleShow === 'all'" @click="plugInDevice('children')">插入子设备</li>
      <li v-if="$auth('centralizedManagement.add') && visibleShow === 'all'" @click="openDrawerEdit2()">编辑</li>
      <li v-if="$auth('centralizedManagement.add') && visibleShow === 'all'" @click="openDrawer2('copy')">复制</li>
      <li v-if="$auth('centralizedManagement.import')" @click="handleImport()">导入设备</li>
      <li v-if="$auth('centralizedManagement.export') && visibleShow === 'all'" @click="derive()">导出当前台账</li>
      <li v-if="$auth('centralizedManagement.del') && visibleShow === 'all'" @click="showDelTip()" style="color: red;">删除</li>
    </ul>
    <drawer-detail ref="drawerDetail" @getTableData="getTableData" @getDataTabs="getDataTabs" @setChildrenData="setChildrenData"></drawer-detail>
    <drawer-detail2 ref="drawerDetail2" @getTableData="getTableData" @getDataTabs="getDataTabs" @setChildrenData="setChildrenData" @updateData="updateData"></drawer-detail2>
    <children-table-modules ref="childrenTableModules" @handleImport="handleImport" @derive="derive"></children-table-modules>
    <drawer-export ref="drawerExport"></drawer-export>
    <import-modal ref="importModal" @getTableData="getTableData"></import-modal>
    <equipment-head-manage ref="equipmentHeadManage" @retrievesTheTableHeader="retrievesTheTableHeader"></equipment-head-manage>
    <search-model ref="searchModel" @setSearchCondition="setSearchCondition"></search-model>
  </div>
</template>
<script>
import SearchForm from '@/views/equipmentLedger/modules/searchForm'
import {
  delEquipment,
  getEquipmentBasicInfo,
  getEquipmentTableData,
  getEquipmentTableTotal
} from '@/api/equipmentLedger'
import DataTabs from '@/views/equipmentLedger/modules/dataTabsModel/dataTabs'
import { getTableScroll } from '@/views/centralizedManagement/modules/height'
import { mapGetters } from 'vuex'
import DrawerDetail from '@/views/centralizedManagement/modules/drawerDetail'
import drawerExport from '@/views/equipmentLedger/modules/drawerExportModel/drawerExport.vue'
import drawerDetail2 from '@/views/centralizedManagement/modules/drawerDetailModules/drawerDetail.vue'
import { getTypeFieldByTypeCode } from '@/api/deviceType'
import moment from 'moment'
import importModal from '@/views/equipmentLedger/modules/importModal/drawerImport.vue'
import tableDrag from '../../../mixins/tableDrag'
import EquipmentHeadManage from '@/views/equipmentLedger/modules/equipmentHeadManage/equipmentHeadManage.vue'
import SearchModel from '@/views/equipmentLedger/modules/searchModel/searchModel.vue'
import ChildrenTableModules from '@/views/centralizedManagement/modules/childrenTableModules/childrenTableModules.vue'

const fourFont1440 = 95
const nbbh1440 = 120
const sbbh1440 = 140
const scrollX1440 = 1080
const fourFontGreaterThan1440 = 130
const nbbhGreaterThan1440 = 135
const sbbhGreaterThan1440 = 140
const scrollXGreaterThan1440 = 1260
export default {
  name: 'TableData',
  mixins: [tableDrag], // 此处不要忘记
  components: {
    ChildrenTableModules,
    EquipmentHeadManage,
    DrawerDetail,
    drawerDetail2,
    drawerExport,
    DataTabs,
    SearchForm,
    SearchModel,
    importModal
  },
  computed: {
    ...mapGetters(['centralizedManagementCompanyId', 'equipmentType']),
    columns: {
      get () {
        let { sortedInfo } = this
        sortedInfo = sortedInfo || {}
        this.columnsData.forEach(item => {
          if (item.sortOrNot) {
            item.sorter = (a, b) => {}
            item.sortOrder = sortedInfo.columnKey === item.dataIndex && sortedInfo.order
          }
          if (!item.isDate) {
            item.onFilterDropdownVisibleChange = visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          }
        })
        return this.columnsData
      },
      set (newValue) {
        this.columnsData = newValue
      }
    },
    columnsInDrawer: {
      get () {
        let { sortedInfo } = this
        sortedInfo = sortedInfo || {}
        this.columnsDataInTable.forEach(item => {
          if (item.sortOrNot) {
            item.sorter = (a, b) => {}
            item.sortOrder = sortedInfo.columnKey === item.dataIndex && sortedInfo.order
          }
          if (!item.isDate) {
            item.onFilterDropdownVisibleChange = visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                })
              }
            }
          }
        })
        return this.columnsDataInTable
      },
      set (newValue) {
        this.columnsDataInTable = newValue
      }
    }
  },
  data () {
    this.components = {
      header: {
        cell: this.resizeableTitle
      }
    }
    return {
      searchValue: '',
      // 表格数据
      tableData: {
        data: [],
        statistics: {
          sumTotal: 0,
          virtualTotal: 0,
          routineTotal: 0
        },
        loading: false
      },
      searchInput: null,
      columnsData: [],
      columnsDataInTable: [],
      originalTableHead: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return record.showIndex ? index + 1 : ''
          },
          align: 'center',
          fixed: 'left',
          width: 40
        },
        {
          title: '设备名称',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          customRender: (text, record, index) => {
            if (record.sign === 1 && record.required) {
              // 虚拟设备和未填写完成
              return <span>
                <a-tooltip placement="top">
                  <template slot="title">该设备的必填项参数未填写，需要后续补充</template>
                  <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #E73B3B7F; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #E73B3BFF">待</span>
                </a-tooltip>
                <a-tooltip placement="top">
                  <template slot="title">该设备为一个虚拟设备，用于设备层级的展示</template>
                  <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #1791FFB2; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #1791FFFF">虚</span>
                </a-tooltip>
                <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
              </span>
            } else if (record.sign === 1) {
              // 虚拟设备
              return <span>
                <a-tooltip placement="top">
                  <template slot="title">该设备为一个虚拟设备，用于设备层级的展示</template>
                  <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #1791FFB2; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #1791FFFF">虚</span>
                </a-tooltip>
                <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
              </span>
            } else if (record.required) {
              // 未填写完成
              return <span>
                <a-tooltip placement="top">
                  <template slot="title">该设备的必填项参数未填写，需要后续补充</template>
                  <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #E73B3B7F; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #E73B3BFF">待</span>
                </a-tooltip>
                <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
              </span>
            } else {
              return <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
            }
          },
          dataIndex: 'name',
          sorter: (a, b) => {},
          align: 'left',
          fixed: 'left',
          width: window.screen.width <= 1440 ? 180 : 285,
          ellipsis: true
        },
        {
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          title: '设备编号',
          dataIndex: 'equipmentNumber',
          customRender: (text, record, index) => {
            return <a-tooltip placement="topLeft"><template slot="title">{record.equipmentNumber}</template><span>{record.equipmentNumber}</span></a-tooltip>
          },
          sorter: (a, b) => {},
          align: 'center',
          ellipsis: true,
          width: window.screen.width <= 1440 ? sbbh1440 : sbbhGreaterThan1440
        },
        {
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          title: '内部编号',
          dataIndex: 'interiorCode',
          customRender: (text, record, index) => {
            return <a-tooltip placement="topLeft"><template slot="title">{record.interiorCode}</template><span>{record.interiorCode}</span></a-tooltip>
          },
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? nbbh1440 : nbbhGreaterThan1440,
          ellipsis: true
        },
        {
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          title: '设备分类',
          dataIndex: 'equipmentTypeName',
          customRender: (text, record, index) => {
            return <a-tooltip placement="topLeft"><template slot="title">{record.equipmentTypeName}</template><span>{record.equipmentTypeName}</span></a-tooltip>
          },
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? fourFont1440 : fourFontGreaterThan1440,
          ellipsis: true
        },
        {
          title: '设备状态',
          dataIndex: 'equipmentStatusName',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'equipmentStatusName'
          },
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? fourFont1440 : fourFontGreaterThan1440,
          ellipsis: true
        },
        {
          title: '特性',
          dataIndex: 'peculiarity',
          scopedSlots: {
            // filterDropdown: 'filterDropdown',
            // filterIcon: 'filterIcon',
            customRender: 'peculiarity'
          },
          // sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? 110 : fourFontGreaterThan1440,
          ellipsis: true
        },
        {
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          title: '归口部门',
          dataIndex: 'relevantdeptname',
          customRender: (text, record, index) => {
            return <a-tooltip placement="topLeft"><template slot="title">{record.relevantdeptname}</template><span>{record.relevantdeptname}</span></a-tooltip>
          },
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? fourFont1440 : fourFontGreaterThan1440,
          ellipsis: true
        },
        {
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          title: '使用部门',
          dataIndex: 'usedeptname',
          customRender: (text, record, index) => {
            return <a-tooltip placement="topLeft"><template slot="title">{record.usedeptname}</template><span>{record.usedeptname}</span></a-tooltip>
          },
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? fourFont1440 : fourFontGreaterThan1440,
          ellipsis: true
        },
        {
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          title: '使用人',
          customRender: (text, record, index) => {
            return <a-tooltip placement="topLeft"><template slot="title">{record.principalName}</template><span>{record.principalName}</span></a-tooltip>
          },
          dataIndex: 'principalName',
          sorter: (a, b) => {},
          align: 'center',
          // width: 100,
          ellipsis: true
        }
        // {
        //   title: '使用年限',
        //   dataIndex: 'ndjar',
        //   customRender: (text, record, index) => {
        //     return <a-tooltip placement="topLeft"><template slot="title">{record.ndjar}</template><span>{record.ndjar}</span></a-tooltip>
        //   },
        //   align: 'center',
        //   width: 80,
        //   ellipsis: true
        // }
        // {
        //   title: '资产信息',
        //   dataIndex: 'assetInfoStatus',
        //   customRender: (text, record, index) => {
        //     return <a-tooltip placement="topLeft"><template slot="title">{record.assetInfoStatus}</template><span>{record.assetInfoStatus}</span></a-tooltip>
        //   },
        //   fixed: 'right',
        //   sorter: (a, b) => {},
        //   align: 'center',
        //   width: 100,
        //   ellipsis: true
        // },
        // {
        //   title: '特',
        //   fixed: 'right',
        //   width: 35,
        //   align: 'center',
        //   scopedSlots: {
        //     customRender: 'actions2'
        //   }
        // },
        // {
        //   title: '密',
        //   fixed: 'right',
        //   width: 35,
        //   align: 'center',
        //   scopedSlots: {
        //     customRender: 'actions3'
        //   }
        // },
        // {
        //   title: '父',
        //   fixed: 'right',
        //   width: 35,
        //   align: 'center',
        //   scopedSlots: {
        //     customRender: 'actions4'
        //   }
        // },
        // {
        //   title: '子',
        //   fixed: 'right',
        //   width: 35,
        //   align: 'center',
        //   scopedSlots: {
        //     customRender: 'actions5'
        //   }
        // },
        // {
        //   title: '运',
        //   fixed: 'right',
        //   width: 45,
        //   align: 'center',
        //   scopedSlots: {
        //     customRender: 'actions6'
        //   }
        // },
        // {
        //   title: '保',
        //   fixed: 'right',
        //   width: 45,
        //   align: 'center',
        //   scopedSlots: {
        //     customRender: 'actions7'
        //   }
        // }
      ],
      originalTableHeadInDrawer: [
        {
          title: '序号1',
          customRender: (text, record, index) => {
            return record.showIndex ? index + 1 : ''
          },
          align: 'center',
          fixed: 'left',
          width: 40
        },
        {
          title: '设备名称',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          customRender: (text, record, index) => {
            if (record.sign === 1 && record.required) {
              // 虚拟设备和未填写完成
              return <span>
                <a-tooltip placement="top">
                  <template slot="title">该设备的必填项参数未填写，需要后续补充</template>
                  <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #E73B3B7F; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #E73B3BFF">待</span>
                </a-tooltip>
                <a-tooltip placement="top">
                  <template slot="title">该设备为一个虚拟设备，用于设备层级的展示</template>
                  <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #1791FFB2; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #1791FFFF">虚</span>
                </a-tooltip>
                <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
              </span>
            } else if (record.sign === 1) {
              // 虚拟设备
              return <span>
                <a-tooltip placement="top">
                  <template slot="title">该设备为一个虚拟设备，用于设备层级的展示</template>
                  <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #1791FFB2; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #1791FFFF">虚</span>
                </a-tooltip>
                <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
              </span>
            } else if (record.required) {
              // 未填写完成
              return <span>
                <a-tooltip placement="top">
                  <template slot="title">该设备的必填项参数未填写，需要后续补充</template>
                  <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #E73B3B7F; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #E73B3BFF">待</span>
                </a-tooltip>
                <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
              </span>
            } else {
              return <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
            }
          },
          dataIndex: 'name',
          sorter: (a, b) => {},
          align: 'left',
          fixed: 'left',
          width: window.screen.width <= 1440 ? 180 : 285,
          ellipsis: true
        },
        {
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          title: '设备编号',
          dataIndex: 'equipmentNumber',
          customRender: (text, record, index) => {
            return <a-tooltip placement="topLeft"><template slot="title">{record.equipmentNumber}</template><span>{record.equipmentNumber}</span></a-tooltip>
          },
          sorter: (a, b) => {},
          align: 'center',
          ellipsis: true,
          width: window.screen.width <= 1440 ? sbbh1440 : sbbhGreaterThan1440
        },
        {
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          title: '内部编号',
          dataIndex: 'interiorCode',
          customRender: (text, record, index) => {
            return <a-tooltip placement="topLeft"><template slot="title">{record.interiorCode}</template><span>{record.interiorCode}</span></a-tooltip>
          },
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? nbbh1440 : nbbhGreaterThan1440,
          ellipsis: true
        },
        {
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          title: '设备分类',
          dataIndex: 'equipmentTypeName',
          customRender: (text, record, index) => {
            return <a-tooltip placement="topLeft"><template slot="title">{record.equipmentTypeName}</template><span>{record.equipmentTypeName}</span></a-tooltip>
          },
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? fourFont1440 : fourFontGreaterThan1440,
          ellipsis: true
        },
        {
          title: '设备状态',
          dataIndex: 'equipmentStatusName',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'equipmentStatusName'
          },
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? fourFont1440 : fourFontGreaterThan1440,
          ellipsis: true
        },
        {
          title: '特性',
          dataIndex: 'peculiarity',
          scopedSlots: {
            // filterDropdown: 'filterDropdown',
            // filterIcon: 'filterIcon',
            customRender: 'peculiarity'
          },
          // sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? 110 : fourFontGreaterThan1440,
          ellipsis: true
        },
        {
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          title: '归口部门',
          dataIndex: 'relevantdeptname',
          customRender: (text, record, index) => {
            return <a-tooltip placement="topLeft"><template slot="title">{record.relevantdeptname}</template><span>{record.relevantdeptname}</span></a-tooltip>
          },
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? fourFont1440 : fourFontGreaterThan1440,
          ellipsis: true
        },
        {
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          title: '使用部门',
          dataIndex: 'usedeptname',
          customRender: (text, record, index) => {
            return <a-tooltip placement="topLeft"><template slot="title">{record.usedeptname}</template><span>{record.usedeptname}</span></a-tooltip>
          },
          sorter: (a, b) => {},
          align: 'center',
          width: window.screen.width <= 1440 ? 120 : fourFontGreaterThan1440,
          ellipsis: true
        },
        {
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon'
          },
          title: '使用人',
          customRender: (text, record, index) => {
            return <a-tooltip placement="topLeft"><template slot="title">{record.principalName}</template><span>{record.principalName}</span></a-tooltip>
          },
          dataIndex: 'principalName',
          sorter: (a, b) => {},
          align: 'center',
          // width: 100,
          ellipsis: true
        }
        // {
        //   title: '使用年限',
        //   dataIndex: 'ndjar',
        //   customRender: (text, record, index) => {
        //     return <a-tooltip placement="topLeft"><template slot="title">{record.ndjar}</template><span>{record.ndjar}</span></a-tooltip>
        //   },
        //   align: 'center',
        //   width: 80,
        //   ellipsis: true
        // }
        // {
        //   title: '资产信息',
        //   dataIndex: 'assetInfoStatus',
        //   customRender: (text, record, index) => {
        //     return <a-tooltip placement="topLeft"><template slot="title">{record.assetInfoStatus}</template><span>{record.assetInfoStatus}</span></a-tooltip>
        //   },
        //   fixed: 'right',
        //   sorter: (a, b) => {},
        //   align: 'center',
        //   width: 100,
        //   ellipsis: true
        // },
        // {
        //   title: '特',
        //   fixed: 'right',
        //   width: 35,
        //   align: 'center',
        //   scopedSlots: {
        //     customRender: 'actions2'
        //   }
        // },
        // {
        //   title: '密',
        //   fixed: 'right',
        //   width: 35,
        //   align: 'center',
        //   scopedSlots: {
        //     customRender: 'actions3'
        //   }
        // },
        // {
        //   title: '父',
        //   fixed: 'right',
        //   width: 35,
        //   align: 'center',
        //   scopedSlots: {
        //     customRender: 'actions4'
        //   }
        // },
        // {
        //   title: '子',
        //   fixed: 'right',
        //   width: 35,
        //   align: 'center',
        //   scopedSlots: {
        //     customRender: 'actions5'
        //   }
        // },
        // {
        //   title: '运',
        //   fixed: 'right',
        //   width: 45,
        //   align: 'center',
        //   scopedSlots: {
        //     customRender: 'actions6'
        //   }
        // },
        // {
        //   title: '保',
        //   fixed: 'right',
        //   width: 45,
        //   align: 'center',
        //   scopedSlots: {
        //     customRender: 'actions7'
        //   }
        // }
      ],
      tableCurrRowId: null,
      dataTabsModel: {},
      sortedInfo: null,
      scrollY: 0,
      scrollX: 0,
      toLeftWidth: 0,
      isFirst: true,
      advanced: false,
      // 搜索条件
      searchModel: {},
      headerSearchModel: {},
      // 导出用到的搜索条件
      exportSearchModel: {},
      searchNum: 0,
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40'],
        showSizeChanger: true,
        showQuickJumper: true
      },
      sort: {},
      // 展开的行
      expandedRowKeys: [],
      // 选中的行
      selectedRows: [],
      selectedRowKeys: [],
      // 左侧树的搜索条件
      treeSearchModel: {},
      // 当前选中展开的数据
      currentlySelectedExpansionData: {},
      visible: false,
      top: 0,
      left: 0,
      visibleShow: '',
      selectedRowsData: {}
    }
  },
  created () {
    // this.scrollX = 1620
    // this.scrollX = window.screen.width <= 1440 ? this.scrollX = scrollX1440 : this.scrollX = scrollXGreaterThan1440
    this.columns = this.originalTableHead
    this.columnsInDrawer = this.originalTableHeadInDrawer
    this.columns.forEach(item => {
      if (item.title !== '序号') {
        const key = 'head_' + item.dataIndex
        this.headerSearchModel[key] = undefined
      }
    })
  },
  directives: {
    drag: {
      bind: function (el) {
        const filtrateDiv = el
        filtrateDiv.onmousedown = (e) => {
          // 获取body的高度
          const filtrateHeight = document.body.clientHeight - 70
          const x = e.clientX - filtrateDiv.offsetLeft
          const y = e.clientY - filtrateDiv.offsetTop
          window.onmousemove = (e) => {
            const cx = e.clientX - x
            let cy = e.clientY - y
            if (cy < 0) {
              cy = 0
            }
            if (cy > filtrateHeight - 35) {
              cy = filtrateHeight - 35
            }
            filtrateDiv.style.left = cx + 'px'
            filtrateDiv.style.top = cy + 'px'
            filtrateDiv.style.cursor = 'grabbing'
          }
          window.onmouseup = (e) => {
            // 移除filtrateDiv.style.left
            filtrateDiv.style.left = null
            filtrateDiv.style.right = '0px'
            filtrateDiv.style.cursor = 'grab'
            window.onmousemove = null
            window.onmouseup = null
          }
        }
      }
    }
  },
  mounted () {
    window.screen.width <= 1440 ? this.scrollX = scrollX1440 : this.scrollX = scrollXGreaterThan1440
  },
  watch: {
    centralizedManagementCompanyId (newValue) {
      for (const item in this.headerSearchModel) {
        this.headerSearchModel[item] = undefined
      }
      // 公司变化时，清空搜索条件中的部分字段，然后重新计算搜索条件数量
      if (this.searchNum > 0) {
        this.searchNum = this.$refs.searchForm.resetFields(this.searchNum)
      } else {
        this.$refs.searchForm.resetFields()
      }
      this.searchModel = this.$refs.searchForm.search('returnModel')
      if (newValue.id !== '') {
        if (newValue.id === '空' || newValue.id === '杭氧') {
          delete this.treeSearchModel.subcompanyid
          this.tableData.data = []
          this.pagination.total = 0
          this.tableData.loading = false
          const dom = document.getElementsByClassName('ant-table-body')[0]
          dom.classList.add('ant-table-body-max-height-0')
          if (this.advanced) {
            this.changeScrollY(90, 'addAssetTableHeigth')
          } else {
            this.changeScrollY(94)
          }
          this.tableData.statistics = {
            sumTotal: 0,
            virtualTotal: 0,
            routineTotal: 0
          }
        } else {
          this.treeSearchModel.subcompanyid = newValue.id
        }
      } else {
        delete this.treeSearchModel.subcompanyid
      }
      if (this.searchModel.subcompanyid) {
        delete this.searchModel.subcompanyid
      }
      if (this.searchModel.usedeptid) {
        delete this.searchModel.usedeptid
      }
      if (newValue.id !== '空') {
        this.setSearchCondition(this.searchModel)
      }
    },
    equipmentType (newValue) {
      if (this.searchModel.equipmentType) {
        delete this.searchModel.equipmentType
      }
      this.searchModel = this.$refs.searchForm.search('returnModel')
      if (newValue.equipmentType !== '' && newValue.equipmentType !== '设备分类') {
        if (newValue.equipmentType === '空') {
          delete this.treeSearchModel.equipmentType
          this.tableData.data = []
          this.pagination.total = 0
          this.tableData.loading = false
          const dom = document.getElementsByClassName('ant-table-body')[0]
          dom.classList.add('ant-table-body-max-height-0')
          if (this.advanced) {
            this.changeScrollY(90, 'addAssetTableHeigth')
          } else {
            this.changeScrollY(94)
          }
          this.tableData.statistics = {
            sumTotal: 0,
            virtualTotal: 0,
            routineTotal: 0
          }
        } else {
          this.treeSearchModel.equipmentType = newValue.equipmentType
          const params = {
            typeCode: newValue.equipmentType,
            type: 3
          }
          this.headerSearchModel = {}
          this.cleanheadInSearchModel()
          getTypeFieldByTypeCode(params).then(res => {
            function elseFun () {
              this.scrollX = window.screen.width <= 1440 ? scrollX1440 : scrollXGreaterThan1440
              this.columns = this.originalTableHead
              this.columnsInDrawer = this.originalTableHeadInDrawer
              this.columns.forEach(item => {
                if (item.title !== '序号') {
                  const key = 'head_' + item.dataIndex
                  this.headerSearchModel[key] = undefined
                }
              })
              this.fixedTableScroll(0, 0)
              this.setSearchCondition(this.searchModel)
            }
            this.resetTableHead(res, true, elseFun)
          }).catch(err => {
            this.scrollX = window.screen.width <= 1440 ? scrollX1440 : scrollXGreaterThan1440
            this.columns = this.originalTableHead
            this.columnsInDrawer = this.originalTableHeadInDrawer
            this.columns.forEach(item => {
              if (item.title !== '序号') {
                const key = 'head_' + item.dataIndex
                this.headerSearchModel[key] = undefined
              }
            })
            this.fixedTableScroll(0, 0)
            this.setSearchCondition(this.searchModel)
          })
        }
      } else {
        delete this.treeSearchModel.equipmentType
        this.headerSearchModel = {}
        this.scrollX = window.screen.width <= 1440 ? scrollX1440 : scrollXGreaterThan1440
        this.columns = this.originalTableHead
        this.columnsInDrawer = this.originalTableHeadInDrawer
        this.columns.forEach(item => {
          if (item.title !== '序号') {
            const key = 'head_' + item.dataIndex
            this.headerSearchModel[key] = undefined
          }
        })
        this.fixedTableScroll(0, 0)
        if (!this.isFirst) {
          this.setSearchCondition(this.searchModel)
        }
      }
      if (newValue.equipmentType !== '空') {
        // console.log('this.searchModel', this.searchModel)
        // this.setSearchCondition(this.searchModel)
      }
    },
    visible (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  methods: {
    // 展开图标
    expandIcon (props) {
      if (props.record.children && (props.record.children.length > 0 || props.record.children.length === 0)) {
        if (props.expanded) {
          return (
            <span
              class="table-icon table-icon-down"
              onClick={(e) => {
                this.tableData.loading = true
                setTimeout(() => {
                  props.record.children = []
                }, 500)
                setTimeout(() => {
                  props.onExpand(props.record, e)
                  this.tableData.loading = false
                }, 500)
              }}
            >
              <a-icon type="caret-down" />
            </span>
          )
        } else {
          return (
            <span
              class="table-icon table-icon-right"
              onClick={(e) => {
                if (props.record.displayType === '1') {
                  // 下拉
                  props.onExpand(props.record, e)
                  this.tableCurrRowId = props.record.id
                  this.getChildren(props.record, true)
                } else {
                  this.tableCurrRowId = props.record.id
                  this.getChildren(props.record, false)
                }
              }}
            >
              <a-icon type="caret-right" />
            </span>
          )
        }
      } else {
        return <span style="margin-right:19px"></span>
      }
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      // 赋值同步本地data接受数据(我这里只取id即可)
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.getAssetTotal()
    },
    // 改变scrollY
    changeScrollY (extraHeight, type) {
      this.$nextTick(() => {
        this.scrollY = getTableScroll(extraHeight, 'assetTable', type)
        const dom = document.getElementById('assetTable')
        if (type === 'addAssetTableHeigth') {
          dom.classList.add('assetTableHeight_126')
        } else {
          dom.classList.remove('assetTableHeight_126')
        }
      })
    },
    // 保存展开状态字段
    saveAdvanced (advanced) {
      this.advanced = advanced
    },
    // 打开抽屉
    openDrawer (type, theRightMouseButton) {
      const obj = { edit: '编辑', copy: '复制' }
      if (['edit', 'copy'].includes(type)) {
        if (this.selectedRows.length === 0) {
          if (!theRightMouseButton) {
            this.$message.error(`请选择需要${obj[type]}的数据！`)
            return
          }
        } else if (this.selectedRows.length > 1) {
          this.$message.error(`只能选择一条数据进行${obj[type]}！`)
          return
        }
      }
      this.$refs.drawerDetail.setTitle(type === 'edit' ? '编辑设备' : '新增设备')
      this.$refs.drawerDetail.setType(type)
      if (['edit', 'copy'].includes(type)) {
        if (theRightMouseButton) {
          this.$refs.drawerDetail.setModel(this.selectedRowsData, type === 'copy' ? 'copy' : undefined)
        } else {
          this.$refs.drawerDetail.setModel(this.selectedRows[0], type === 'copy' ? 'copy' : undefined)
        }
      }
      this.$refs.drawerDetail.open(true)
    },
    // 打开抽屉（新增/复制）
    openDrawer2 (type) {
      if (type === 'copy') {
        this.$refs.drawerDetail2.setModel(this.selectedRowsData, 'copy')
      }
      this.$refs.drawerDetail2.setTitle('新增设备')
      this.$refs.drawerDetail2.setType(type)
      this.$refs.drawerDetail2.setPname('一级设备')
      this.$refs.drawerDetail2.open(true)
    },
    // 打开抽屉编辑
    openDrawerEdit2 () {
      this.$refs.drawerDetail2.setModel(JSON.parse(JSON.stringify(this.selectedRowsData)))
      this.$refs.drawerDetail2.setTitle('编辑设备')
      this.$refs.drawerDetail2.setType('edit')
      this.$refs.drawerDetail2.open(true)
    },
    showDelTip () {
      const that = this
      that.$confirm({
        title: (h) => {
          return h('div', {
            domProps: {
              innerHTML: '确定删除该数据吗'
            }
          })
        },
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          that.del()
        },
        onCancel () {

        }
      })
    },
    // 删除
    del () {
      function findById (treeData, id) {
        for (const item of treeData) {
          if (item.id === id) {
            return item
          } else if (item.children) {
            const result = findById(item.children, id)
            if (result) {
              return result
            }
          }
        }
        return null
      }
      if (this.selectedRowsData.pnode) {
        this.$message.error('当前数据包含子节点，不允许删除')
        return
      }
      const data = {
        ids: this.selectedRowsData.id
      }
      this.btnLoading = true
      delEquipment(data).then(res => {
        if (res.status === 0) {
          if (this.exportSearchModel.hasOwnProperty('pid')) {
            if (this.selectedRowsData.pid !== '0') {
              // 找到要删除节点的父节点
              const pData = findById(this.tableData.data, this.selectedRowsData.pid)
              // 获取到要删除节点在父节点中的下标
              const findIndex = pData.children.findIndex(item => item.id === this.selectedRowsData.id)
              // 删除节点
              pData.children.splice(findIndex, 1)
              if (pData.children.length === 0) {
                pData.pnode = false
                delete pData.children
              }
            } else {
              this.getTableData(true)
            }
          } else {
            this.getTableData(true)
          }
          this.$message.success('删除成功！')
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 导入
    handleImport () {
      this.$refs.importModal.open(true)
    },
    // 导出
    derive (searchModel) {
      this.$refs.drawerExport.setTitle('导出')
      this.$refs.drawerExport.setModel(this.exportSearchModel)
      this.$refs.drawerExport.setType(this.$sysInfo.MODAL_ADD)
      // this.$refs.drawerExport.setEquipmentType(this.equipmentType.equipmentType)
      this.$refs.drawerExport.open(true)
    },
    // 修改表格数据
    formateData (data) {
      const childrenArr = []
      const that = this
      data.forEach(item => {
        item.showIndex = false
        that.columns.forEach(item2 => {
          if (item2.type === 2) {
            item[item2.dataIndex] = item.paramValueMap[item2.dataIndex]
          }
          if (item2.type === 3) {
            item[item2.dataIndex] = item.typeParamValueMap[item2.dataIndex]
          }
          if (item2.type === 4) {
            item[item2.dataIndex] = item.peculiarityMap[item2.dataIndex]
          }
        })
        if (item.children) {
          item.marginRight = true
          this.formateData(item.children)
        } else {
          item.marginLeft = true
        }
        childrenArr.push(item)
      })
      return childrenArr
    },
    // 获取表格数据
    getTableData (resetModel) {
      const that = this
      function disposalData (item) {
        that.columns.forEach(item2 => {
          if (item2.type === 2) {
            item[item2.dataIndex] = item.paramValueMap ? item.paramValueMap[item2.dataIndex] : ''
          }
          if (item2.type === 3) {
            item[item2.dataIndex] = item.typeParamValueMap ? item.typeParamValueMap[item2.dataIndex] : ''
          }
          if (item2.type === 4) {
            item[item2.dataIndex] = item.peculiarityMap ? item.peculiarityMap[item2.dataIndex] : ''
          }
        })
      }
      this.tableData.loading = true
      this.searchModel = { ...this.searchModel, ...this.pagination, ...this.sort, pid: 0 }
      // this.expandedRowKeys = ["214d0b67b68043009ab7a500c43d8f0f","123129830921831","123129830921832"]
      // this.tableCurrRowId = "123129830921831"
      this.expandedRowKeys = []
      this.selectedRows = []
      this.selectedRowKeys = []
      if (this.searchModel.delpid) {
        delete this.searchModel.pid
      }
      // delete this.searchModel.delpid
      const params = JSON.parse(JSON.stringify(this.searchModel))
      let delPid = false
      for (const key in params) {
        if (key.indexOf('head_') > -1) {
          delPid = true
          const checkKey = key.split('_')[1]
          params[checkKey] = params[key]
          delete params[key]
        }
      }
      if (delPid) {
        delete params.pid
      }
      this.exportSearchModel = params
      getEquipmentTableData(params).then(res => {
        if (res.status === 0) {
          res.data.list.forEach((item, index) => {
            item.showIndex = true
            if (params.hasOwnProperty('pid')) {
              if (item.pnode) {
                item.children = []
              } else {
                delete item.children
              }
            } else {
              delete item.children
            }
            disposalData(item)
            if (item.children) {
              // 修改表格数据
              item.marginRight = true
              item.children = this.formateData(item.children)
            }
          })
          if (res.data.list.length > 0) {
            this.tableData.data = res.data.list
            this.pagination.total = res.data.total
            if (resetModel) {
              this.dataTabsModel = this.tableData.data[0]
              this.tableCurrRowId = this.tableData.data[0].id
            }
          } else {
            this.tableData.data = []
            this.pagination.total = 0
            this.dataTabsModel = {}
            this.tableCurrRowId = ''
          }
          this.$nextTick(() => {
            // 获取ant-table-body的dom，并且给它添加鼠标右键事件
            const tableBodyDom = document.getElementsByClassName('ant-table-body')[0]
            const tableBodyDom2 = document.getElementsByClassName('ant-empty-normal')[0]
            const tableBodyDom3 = document.getElementsByClassName('ant-table-fixed-left')[0]
            const tableBodyDom4 = document.getElementsByClassName('ant-table-placeholder')[0]
            tableBodyDom.oncontextmenu = this.openContextmenu
            if (tableBodyDom2) {
              tableBodyDom2.oncontextmenu = this.openContextmenu
            }
            if (tableBodyDom3) {
              tableBodyDom3.oncontextmenu = this.openContextmenu
            }
            if (tableBodyDom4) {
              tableBodyDom4.oncontextmenu = this.openContextmenu
            }
          })
          this.tableData.loading = false
          if (this.advanced) {
            this.changeScrollY(90, 'addAssetTableHeigth')
          } else {
            this.changeScrollY(94)
          }
        } else {
          this.tableData.data = []
          this.tableData.total = 0
          this.tableData.loading = false
          this.$message.error(res.info.message)
        }
      })
      // 获取资产统计
      this.getAssetTotal()
    },
    // 获取子数据
    getChildren (data, pushChildren) {
      if (pushChildren) {
        this.currentlySelectedExpansionData = data
        const params = {
          pid: data.id,
          paging: false
        }
        this.tableData.loading = true
        getEquipmentTableData(params).then(res => {
          if (res.status === 0) {
            if (res.data.length > 0) {
              for (const resData of res.data) {
                if (resData.pnode) {
                  resData.children = []
                } else {
                  delete resData.children
                }
              }
              // data.children = res.data
              const findChildrenIndex = (table) => {
                for (const item of table) {
                  if (item.id === data.id) {
                    item.children = res.data
                    break
                  } else {
                    if (item.children) {
                      findChildrenIndex(item.children)
                    }
                  }
                }
              }
              findChildrenIndex(this.tableData.data)
            }
            this.tableData.loading = false
          } else {
            this.$message.error(res.info.message)
          }
        })
      } else {
        this.$refs.childrenTableModules.setTitle(`${data.name}的子设备列表`)
        this.$refs.childrenTableModules.setTableColumns(this.columnsInDrawer)
        this.$refs.childrenTableModules.setpModel(data)
        this.$refs.childrenTableModules.setScrollX(this.scrollX)
        this.$refs.childrenTableModules.open(true)
      }
    },
    // 获取资产统计
    getAssetTotal () {
      const params = JSON.parse(JSON.stringify(this.exportSearchModel))
      if (this.selectedRowKeys.length > 0) {
        params.idList = this.selectedRowKeys
      }
      getEquipmentTableTotal(params).then(res => {
        if (res.status === 0) {
          if (res.data) {
            this.tableData.statistics = res.data
          } else {
            this.tableData.statistics = {
              sumTotal: 0,
              virtualTotal: 0,
              routineTotal: 0
            }
          }
        }
      })
    },
    async handleSearch (selectedKeys, confirm, column) {
      // searchForm
      const key = 'head_' + column.dataIndex
      this.headerSearchModel[key] = typeof selectedKeys[0] === 'object' ? selectedKeys[0].format('YYYY-MM-DD') : selectedKeys[0]
      const searchModel = this.$refs.searchForm.search('returnModel')
      await this.collateSearchData(searchModel)
      await this.setSearchCondition(this.searchModel)
      // confirm()
    },
    handleReset (clearFilters, column) {
      const key = 'head_' + column.dataIndex
      this.headerSearchModel[key] = undefined
      delete this.searchModel[key]
      this.setSearchCondition(this.searchModel)
    },
    // 清除表头搜索字段
    cleanheadInSearchModel () {
      for (const key in this.headerSearchModel) {
        this.headerSearchModel[key] = undefined
      }
    },
    // 定位表格滚动条至指定位置
    fixedTableScroll (scrollLeft, scrollTop) {
      this.$nextTick(() => {
        const tableBody = document.getElementById('assetTable').getElementsByClassName('ant-table-body')[0]
        tableBody.scrollLeft = scrollLeft
        tableBody.scrollTop = scrollTop
      })
    },
    // 整理搜索数据
    collateSearchData (searchModel) {
      return new Promise((resolve, reject) => {
        this.searchModel = searchModel
        for (const key in this.searchModel) {
          if (key.indexOf('head_') > -1) {
            delete this.searchModel[key]
          }
        }
        const obj = {}
        if (this.searchModel) {
          try {
            for (const key in this.headerSearchModel) {
              if (this.headerSearchModel[key] !== undefined) {
                // 取heat_后面的字段
                const checkKey = key.split('_')[1]
                if (checkKey === 'equipmentStatusName') {
                  // 设备状态
                  if (this.searchModel.equipmentStatus) {
                    // 抛出异常
                    throw new Error('表头搜素条件和顶部搜索条件冲突')
                  }
                }
                // 归口部门
                if (checkKey === 'relevantdeptname') {
                  if (this.searchModel.relevantdeptid) {
                    // 抛出异常
                    throw new Error('表头搜素条件和顶部搜索条件冲突')
                  }
                }
                // 归口部门负责人
                if (checkKey === 'relevantdeptUserName') {
                  if (this.searchModel.relevantdeptUserId) {
                    // 抛出异常
                    throw new Error('表头搜素条件和顶部搜索条件冲突')
                  }
                }
                // 使用部门
                if (checkKey === 'usedeptname') {
                  if (this.searchModel.usedeptid) {
                    // 抛出异常
                    throw new Error('表头搜素条件和顶部搜索条件冲突')
                  }
                }
                // 判断this.searchModel对象中是否有key属性
                if (checkKey in this.searchModel) {
                  // 抛出异常
                  throw new Error('表头搜素条件和顶部搜索条件冲突')
                }
                obj[key] = this.headerSearchModel[key]
              }
            }
          } catch (error) {
            this.$message.error('表头搜素条件和顶部搜索条件冲突')
            return
          }
        }
        this.searchModel = { ...this.searchModel, ...this.treeSearchModel, ...obj, ...searchModel }
        resolve()
      })
      // return this.searchModel
    },
    // 搜索
    setSearchCondition (searchModel, changeSearch, searchNum, notSearch) {
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = searchModel
      if (changeSearch) {
        this.$refs.searchForm.changeSearchModel(searchModel)
        this.searchNum = searchNum
      }
      for (const key in this.searchModel) {
        if (key.indexOf('head_') > -1) {
          delete this.searchModel[key]
        }
      }
      const obj = {}
      if (this.searchModel) {
        try {
          for (const key in this.headerSearchModel) {
            if (this.headerSearchModel[key] !== undefined) {
              // 取heat_后面的字段
              const checkKey = key.split('_')[1]
              if (checkKey === 'equipmentStatusName') {
                // 设备状态
                if (this.searchModel.equipmentStatus) {
                  // 抛出异常
                  throw new Error('表头搜素条件和顶部搜索条件冲突')
                }
              }
              // 归口部门
              if (checkKey === 'relevantdeptname') {
                if (this.searchModel.relevantdeptid) {
                  // 抛出异常
                  throw new Error('表头搜素条件和顶部搜索条件冲突')
                }
              }
              // 归口部门负责人
              if (checkKey === 'relevantdeptUserName') {
                if (this.searchModel.relevantdeptUserId) {
                  // 抛出异常
                  throw new Error('表头搜素条件和顶部搜索条件冲突')
                }
              }
              // 使用部门
              if (checkKey === 'usedeptname') {
                if (this.searchModel.usedeptid) {
                  // 抛出异常
                  throw new Error('表头搜素条件和顶部搜索条件冲突')
                }
              }
              // 判断this.searchModel对象中是否有key属性
              if (checkKey in this.searchModel) {
                // 抛出异常
                throw new Error('表头搜素条件和顶部搜索条件冲突')
              }
              obj[key] = this.headerSearchModel[key]
            }
          }
        } catch (error) {
          this.$message.error('表头搜素条件和顶部搜索条件冲突')
          return
        }
      }
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel, ...obj, ...searchModel }
      this.expandedRowKeys = []
      this.tableCurrRowId = ''
      this.isFirst = false
      if (!notSearch) {
        this.getTableData(true)
      }
    },
    // 重置
    clearSearch (searchModel) {
      this.sort = {}
      this.sortedInfo = null
      this.pagination.pageNum = 1
      this.pagination.current = 1
      this.searchModel = searchModel
      this.searchNum = 0
      const obj = {}
      if (this.searchModel) {
        try {
          for (const key in this.headerSearchModel) {
            if (this.headerSearchModel[key] !== undefined) {
              // 取heat_后面的字段
              const checkKey = key.split('_')[1]
              if (checkKey === 'equipmentStatusName') {
                // 设备状态
                if (this.searchModel.equipmentStatus) {
                  // 抛出异常
                  throw new Error('表头搜素条件和顶部搜索条件冲突')
                }
              }
              // 归口部门
              if (checkKey === 'relevantdeptname') {
                if (this.searchModel.relevantdeptid) {
                  // 抛出异常
                  throw new Error('表头搜素条件和顶部搜索条件冲突')
                }
              }
              // 归口部门负责人
              if (checkKey === 'relevantdeptUserName') {
                if (this.searchModel.relevantdeptUserId) {
                  // 抛出异常
                  throw new Error('表头搜素条件和顶部搜索条件冲突')
                }
              }
              // 使用部门
              if (checkKey === 'usedeptname') {
                if (this.searchModel.usedeptid) {
                  // 抛出异常
                  throw new Error('表头搜素条件和顶部搜索条件冲突')
                }
              }
              // 判断this.searchModel对象中是否有key属性
              if (checkKey in this.searchModel) {
                // 抛出异常
                throw new Error('表头搜素条件和顶部搜索条件冲突')
              }
              obj[key] = this.headerSearchModel[key]
            }
          }
        } catch (error) {
          this.$message.error('表头搜素条件和顶部搜索条件冲突')
          return
        }
      }
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel, ...obj }
      this.expandedRowKeys = []
      this.tableCurrRowId = ''
      this.getTableData(true)
    },
    // 切换页码等操作
    handleTableChange (pagination, filters, sorter) {
      this.sortedInfo = sorter
      this.pagination.pageNum = 1
      this.sort.sortName = sorter.field
      if (sorter.order) {
        if (sorter.order === 'ascend') {
          this.sort.sortType = 'asc'
        } else if (sorter.order === 'descend') {
          this.sort.sortType = 'desc'
        }
      } else {
        delete this.sort.sortName
        delete this.sort.sortType
        delete this.searchModel.sortName
        delete this.searchModel.sortType
      }
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel }
      for (const key in this.searchModel) {
        if (key.indexOf('head_') > -1) {
          this.headerSearchModel[key] = this.searchModel[key]
        }
      }
      this.expandedRowKeys = []
      this.tableCurrRowId = ''
      this.getTableData(true)
    },
    // 切换页码等操作
    handleTableChange2 (pageNum, pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.pageNum = pageNum
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel }
      this.expandedRowKeys = []
      this.tableCurrRowId = ''
      this.getTableData(true)
    },
    handleTableSize (pageNum, pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.pageNum = pageNum
      this.searchModel = { ...this.searchModel, ...this.treeSearchModel }
      this.expandedRowKeys = []
      this.tableCurrRowId = ''
      this.getTableData(true)
    },
    // 关闭右键菜单
    closeMenu () {
      this.visible = false
    },
    // 行点击
    changeRow (record) {
      return {
        on: {
          // 鼠标右键
          contextmenu: (e) => {
            e.preventDefault()
            e.stopPropagation()
            this.$emit('closeMenu', 'rightTable')
            this.selectedRowsData = record
            this.tableCurrRowId = record.id
            this.top = e.pageY - 53
            this.left = e.pageX - 251
            this.visibleShow = 'all'
            this.visible = true
          },
          // 鼠标双击
          dblclick: (event) => { // 双击行,双击选中
            if (this.$auth('centralizedManagement.edit')) {
              if (!record.dblclickDisabled) {
                this.selectedRowsData = record
                this.$refs.drawerDetail2.setTitle('编辑设备')
                this.$refs.drawerDetail2.setType('edit')
                this.$refs.drawerDetail2.setModel(JSON.parse(JSON.stringify(record)))
                this.$refs.drawerDetail2.open(true)
              }
            }
          },
          // 鼠标单击
          click: (event) => { // 单击行,双击选中
            this.tableCurrRowId = record.id
            this.dataTabsModel = {}
            this.dataTabsModel = record
          }
        }
      }
    },
    openContextmenu (e) {
      e.preventDefault()
      e.stopPropagation()
      this.$emit('closeMenu', 'rightTable')
      this.top = e.pageY - 53
      this.left = e.pageX - 251
      this.visibleShow = 'part'
      this.visible = true
    },
    // 右键插入设备
    plugInDevice (type) {
      if (type === 'father') {
      //  插入父设备
        if (this.selectedRowsData.pid !== '0' && this.selectedRowsData.pid !== null) {
          this.$message.warning('该设备已存在父设备，无法添加父设备')
        } else {
          this.tableCurrRowId = this.selectedRowsData.id
          this.dataTabsModel = {}
          this.dataTabsModel = this.selectedRowsData
          this.$refs.drawerDetail2.setTitle('新增父设备')
          this.$refs.drawerDetail2.setType('add')
          this.$refs.drawerDetail2.setSonId(this.selectedRowsData.id)
          this.$refs.drawerDetail2.setPname('一级设备')
          this.$refs.drawerDetail2.setDataTabsModel(this.selectedRowsData)
          this.$refs.drawerDetail2.open(true)
        }
      } else {
        this.tableCurrRowId = this.selectedRowsData.id
        this.dataTabsModel = {}
        this.dataTabsModel = this.selectedRowsData
        //  插入子设备
        this.$refs.drawerDetail2.setTitle('新增子设备')
        this.$refs.drawerDetail2.setType('add')
        this.$refs.drawerDetail2.setPid(this.selectedRowsData.id)
        this.$refs.drawerDetail2.setPname(this.selectedRowsData.name)
        this.$refs.drawerDetail2.setDataTabsModel(this.selectedRowsData)
        this.$refs.drawerDetail2.open(true)
      }
    },
    // 子设备新增成功之后插入子设备
    setChildrenData (data, length) {
      // data.children = []
      if (this.exportSearchModel.hasOwnProperty('pid')) {
        if (length > 1) {
          if (this.selectedRowsData.children) {
            data.forEach(item => {
              if (this.selectedRowsData.children) {
                this.selectedRowsData.children.push(item)
              }
            })
          } else {
            this.selectedRowsData.children = data
          }
        } else {
          if (this.selectedRowsData.children) {
            this.selectedRowsData.children.push(data[0])
          } else {
            this.selectedRowsData.children = data
          }
          if (this.expandedRowKeys.indexOf(this.selectedRowsData.id) === -1) {
            this.expandedRowKeys.push(this.selectedRowsData.id)
          }
          this.tableCurrRowId = data[0].id
          this.$forceUpdate()
        }
      } else {
        this.getTableData(true)
      }
    },
    // 编辑成功之后更新数据
    updateData (data) {
      this.tableData.loading = true
      let childeren = []
      if (this.selectedRowsData.children) {
        childeren = JSON.parse(JSON.stringify(this.selectedRowsData.children))
      }
      for (const dataKey in data) {
        this.selectedRowsData[dataKey] = data[dataKey]
      }
      if (childeren.length > 0) {
        this.selectedRowsData.children = childeren
      }
      this.tableData.loading = false
      this.getDataTabs(data.id)
      this.$forceUpdate()
    },
    // 根据给的id获取详情
    getDataTabs (id) {
      this.dataTabsModel = {}
      const data = {
        id: id
      }
      getEquipmentBasicInfo(data).then(res => {
        if (res.status === 0) {
          this.dataTabsModel = res.data
        }
      })
    },
    rowClassName (record, index) {
      return (record.id === this.tableCurrRowId) ? 'yellow' : ''
    },
    // 重置表头
    resetTableHead (res, changeEquipment, elseFun) {
      if (res.status === 0) {
        if (res.data.length > 0) {
          let width = 0
          const table = JSON.parse(JSON.stringify(res.data))
          const tableInDrawer = JSON.parse(JSON.stringify(res.data))
          table.forEach((item, index) => {
            item.ellipsis = true
            item.width = 200
            item.align = 'center'
            if (item.dataIndex !== 'equipmentStatusName') {
              item.customRender = (text, record, index) => {
                return <a-tooltip placement="topLeft"><template slot="title">{record[item.dataIndex]}</template><span>{record[item.dataIndex]}</span></a-tooltip>
              }
            }
            if (index === 0) {
              item.fixed = 'left'
              item.align = 'left'
              item.customRender = (text, record, index) => {
                if (record.sign === 1 && record.required) {
                  // 虚拟设备和未填写完成
                  return <span>
                    <a-tooltip placement="top">
                      <template slot="title">该设备的必填项参数未填写，需要后续补充</template>
                      <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #E73B3B7F; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #E73B3BFF">待</span>
                    </a-tooltip>
                    <a-tooltip placement="top">
                      <template slot="title">该设备为一个虚拟设备，用于设备层级的展示</template>
                      <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #1791FFB2; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #1791FFFF">虚</span>
                    </a-tooltip>
                    <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
                  </span>
                } else if (record.sign === 1) {
                  // 虚拟设备
                  return <span>
                    <a-tooltip placement="top">
                      <template slot="title">该设备为一个虚拟设备，用于设备层级的展示</template>
                      <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #1791FFB2; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #1791FFFF">虚</span>
                    </a-tooltip>
                    <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
                  </span>
                } else if (record.required) {
                  // 未填写完成
                  return <span>
                    <a-tooltip placement="top">
                      <template slot="title">该设备的必填项参数未填写，需要后续补充</template>
                      <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #E73B3B7F; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #E73B3BFF">待</span>
                    </a-tooltip>
                    <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
                  </span>
                } else {
                  return <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
                }
              }
            }
            if (index === res.data.length - 1) {
              item.width = null
            }
            if (item.isDate) {
              item.customRender = (text, record, index) => {
                return record[item.dataIndex] ? moment(record[item.dataIndex]).format('YYYY-MM-DD') : ''
              }
              // delete item.scopedSlots
            }
            if (item.type === 1) {
              item.scopedSlots = {
                ...item.scopedSlots,
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon'
              }
            }
            width += item.width
            const key = 'head_' + item.dataIndex
            this.headerSearchModel[key] = undefined
            if (!changeEquipment) {
              if (this.searchModel[key]) {
                this.headerSearchModel[key] = this.searchModel[key]
              }
            }
          })
          table.unshift(
            {
              title: '序号',
              customRender: (text, record, index) => {
                return record.showIndex ? index + 1 : ''
              },
              align: 'center',
              fixed: 'left',
              width: 40,
              setWidth: true
            }
          )
          // res.data.push(
          //   {
          //     title: '特',
          //     fixed: 'right',
          //     width: 35,
          //     align: 'center',
          //     scopedSlots: {
          //       customRender: 'actions2'
          //     },
          //     setWidth: true
          //   },
          //   {
          //     title: '密',
          //     fixed: 'right',
          //     width: 35,
          //     align: 'center',
          //     scopedSlots: {
          //       customRender: 'actions3'
          //     },
          //     setWidth: true
          //   },
          //   {
          //     title: '父',
          //     fixed: 'right',
          //     width: 35,
          //     align: 'center',
          //     scopedSlots: {
          //       customRender: 'actions4'
          //     },
          //     setWidth: true
          //   },
          //   {
          //     title: '子',
          //     fixed: 'right',
          //     width: 35,
          //     align: 'center',
          //     scopedSlots: {
          //       customRender: 'actions5'
          //     },
          //     setWidth: true
          //   },
          //   {
          //     title: '运',
          //     fixed: 'right',
          //     width: 45,
          //     align: 'center',
          //     scopedSlots: {
          //       customRender: 'actions6'
          //     },
          //     setWidth: true
          //   },
          //   {
          //     title: '保',
          //     fixed: 'right',
          //     width: 45,
          //     align: 'center',
          //     scopedSlots: {
          //       customRender: 'actions7'
          //     },
          //     setWidth: true
          //   }
          // )

          tableInDrawer.forEach((item, index) => {
            item.ellipsis = true
            item.width = 200
            item.align = 'center'
            if (item.dataIndex !== 'equipmentStatusName') {
              item.customRender = (text, record, index) => {
                return <a-tooltip placement="topLeft"><template slot="title">{record[item.dataIndex]}</template><span>{record[item.dataIndex]}</span></a-tooltip>
              }
            }
            if (index === 0) {
              item.fixed = 'left'
              item.align = 'left'
              item.customRender = (text, record, index) => {
                if (record.sign === 1 && record.required) {
                  // 虚拟设备和未填写完成
                  return <span>
                    <a-tooltip placement="top">
                      <template slot="title">该设备的必填项参数未填写，需要后续补充</template>
                      <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #E73B3B7F; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #E73B3BFF">待</span>
                    </a-tooltip>
                    <a-tooltip placement="top">
                      <template slot="title">该设备为一个虚拟设备，用于设备层级的展示</template>
                      <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #1791FFB2; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #1791FFFF">虚</span>
                    </a-tooltip>
                    <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
                  </span>
                } else if (record.sign === 1) {
                  // 虚拟设备
                  return <span>
                    <a-tooltip placement="top">
                      <template slot="title">该设备为一个虚拟设备，用于设备层级的展示</template>
                      <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #1791FFB2; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #1791FFFF">虚</span>
                    </a-tooltip>
                    <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
                  </span>
                } else if (record.required) {
                  // 未填写完成
                  return <span>
                    <a-tooltip placement="top">
                      <template slot="title">该设备的必填项参数未填写，需要后续补充</template>
                      <span style="marginRight: 5px; backgroundColor: #FFFFFFFF; border: 1px solid #E73B3B7F; fontSize: 12px; padding: 2px 4px; borderRadius: 3px; color: #E73B3BFF">待</span>
                    </a-tooltip>
                    <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
                  </span>
                } else {
                  return <a-tooltip placement="topLeft"><template slot="title">{record.name}</template><span>{record.name}</span></a-tooltip>
                }
              }
            }
            if (index === res.data.length - 1) {
              item.width = null
            }
            if (item.isDate) {
              item.customRender = (text, record, index) => {
                return record[item.dataIndex] ? moment(record[item.dataIndex]).format('YYYY-MM-DD') : ''
              }
            }
            if (item.type === 1) {
              item.scopedSlots = {
                ...item.scopedSlots,
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon'
              }
            }
          })
          tableInDrawer.unshift(
            {
              title: '序号',
              customRender: (text, record, index) => {
                return record.showIndex ? index + 1 : ''
              },
              align: 'center',
              fixed: 'left',
              width: 40,
              setWidth: true
            }
          )
          this.scrollX = width + 235
          this.columns = table
          this.columnsInDrawer = tableInDrawer
          if (!changeEquipment) {
            this.fixedTableScroll(0, 0)
            this.tableData.loading = false
          } else {
            this.setSearchCondition(this.searchModel)
          }
        } else {
          elseFun()
        }
      } else {
        elseFun()
      }
    },
    // 判断是否需要重新获取表头
    retrievesTheTableHeader (list) {
      const that = this
      if (list.findIndex(item => item === this.equipmentType.equipmentType) >= 0) {
        const params = {
          typeCode: this.equipmentType.equipmentType,
          type: 3
        }
        this.headerSearchModel = {}
        this.tableData.loading = true
        this.cleanheadInSearchModel()
        getTypeFieldByTypeCode(params).then(res => {
          function elseFun () {
            that.scrollX = window.screen.width <= 1440 ? scrollX1440 : scrollXGreaterThan1440
            that.columns = that.originalTableHead
            that.columnsInDrawer = that.originalTableHeadInDrawer
            that.columns.forEach(item => {
              if (item.title !== '序号') {
                const key = 'head_' + item.dataIndex
                that.headerSearchModel[key] = undefined
                if (that.searchModel[key]) {
                  that.headerSearchModel[key] = that.searchModel[key]
                }
              }
            })
            that.fixedTableScroll(0, 0)
            that.tableData.loading = false
          }
          this.resetTableHead(res, false, elseFun)
        }).catch(err => {
          this.scrollX = window.screen.width <= 1440 ? scrollX1440 : scrollXGreaterThan1440
          this.columns = this.originalTableHead
          this.columnsInDrawer = this.originalTableHeadInDrawer
          this.columns.forEach(item => {
            if (item.title !== '序号') {
              const key = 'head_' + item.dataIndex
              this.headerSearchModel[key] = undefined
              if (this.searchModel[key]) {
                this.headerSearchModel[key] = this.searchModel[key]
              }
            }
          })
          this.fixedTableScroll(0, 0)
          this.tableData.loading = false
        })
      }
    },
    showEquipmentHeadManage () {
      this.$refs.equipmentHeadManage.open()
    },
    // 设置单元格背景色
    setBgc (record) {
      return { style: { background: '#0451A8' } }
    },
    // 打开详细查询弹窗
    showSearchModel () {
      this.$nextTick(() => {
        this.$refs.searchModel.open(true)
        this.$refs.searchModel.setSearchModel(this.searchModel)
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.ant-table-tbody {
  cursor: pointer;
}
/deep/.ant-table-tbody .yellow{
  background-color: rgba(253, 250, 199, 1) !important;
}
.rightTableDiv {
  height: 100%;
  overflow-x: hidden;
  position: relative;
  .filtrate,.filtrateNum {
    width: 80px;
    position: absolute;
    right: 0;
    background: #1791FF;
    box-shadow: 0px 5px 10px 0px rgba(8,64,159,0.5);
    border-radius: 3px;
    z-index: 999;
    cursor: grab;
    span {
      color: #FFFFFF;
    }
  }
  .filtrate {
    height: 32px;
    top: 0px;
    line-height: 32px;
    text-align: center;
    span {
      font-size: 14px;
      color: #FFFFFF;
    }
  }
  .filtrateNum {
    height: 60px;
    top: 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .circle {
      width: 20px;
      height: 20px;
      border-radius: 10px;
      margin-top: 6px;
      background: #FFFFFF;
      box-shadow: 0px 5px 10px 0px rgba(8,64,159,0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: row;
      span {
        color: #1791FF;
        font-size: 12px;
      }
    }
  }
  /deep/.assetTable  {
    transition: height 300ms ease;
    height: calc(60% - 90px);
    >.ant-spin-nested-loading {
      height: 100%;
      >.ant-spin-container {
        height: 100%;
        .ant-table {
          height: 100%;
          table {
            border-collapse: collapse !important;
          }
          .ant-table-content {
            height: 100%;
            .ant-table-scroll{
              height: 100%;
              .ant-table-body {
                transition: max-height 300ms ease;
                height: calc(100% - 80px);
              }
              >.ant-table-placeholder {
                position: absolute;
                background: none;
                border-top: none;
                border-bottom: none;
                border-radius: 0 0 4px 4px;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                height: 100px;
                .ant-empty-normal {
                  margin: 0 !important;
                }
              }
            }
          }
        }
        >.ant-table-pagination.ant-pagination {
          margin: 10px 0 0 0 !important;
        }
      }
    }
    .ant-table-pagination.ant-pagination {
      margin: 10px;
    }
  }
}
.listContent {
  .table {
    margin-top: 10px;
  }
}
.ant-table-row-collapsed::after {
  content: '+';
  color: #DDDDDD;
}
.ant-table-row-expanded::after {
  content: '-';
  color: #DDDDDD;
}
/deep/.ant-table-footer {
  padding: 0 !important;
  height: 40px;
  .footerDiv {
    display: flex;
    flex-direction: row;
    //justify-content: space-between;
    background-color: #FFFFFF;
    //background-color: #E7F4FF;
    height: 100%;
    font-size: 14px;
    font-weight: 500;
    .footerDivOne ,.footerDivTwo ,.footerDivThree {
      //width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      //justify-content: flex-start;
      align-items: center;
      padding: 0 20px;
      color: #333333;
      background-color: #E7F4FF;
      font-weight: 500;
      span:first-child {
        //margin-right: 20px;
      }
    }
    .footerDivOne {
      width: calc(100% / 3 - 2px);
      //border-right: 1px solid #DDDDDD;
    }
    .footerDivTwo {
      width: calc(100% / 3 - 4px);
      //border-right: 1px solid #DDDDDD;
      margin: 0 auto;
    }
    .footerDivThree {
      width: calc(100% / 3 - 2px);
    }
  }
}
/deep/.ant-table-expanded-row{
  >td{
    padding: 0;
    .expand_row{
      display: flex;
      .expand_left{
        width: 80px;
        border-right: 1px solid #e8e8e8;
      }
      .expand_right{
        width: calc(100% - 80px);
        //padding: 0 10px 8px 10px;
      }
    }
  }
}
.assetTableHeight_126 {
  height: calc(60% - 174px) !important;
}
.assetNameTable {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
/deep/.ant-table-row {
  td {
    padding: 6px 10px !important;
    position: relative;
  }
  .ant-table-column-has-sorters:nth-child(3) {
    //display: flex;
    //height: 43px;
    //flex-direction: row;
    //justify-content: center;
    //align-items: center;
  }
}
.table-icon {
  margin-right: 7px;
  color: #87909f;
  font-size: 12px;
  cursor: pointer;
}
.table-icon-down {
  color: #08409f;
}
.table-icon-right {
  color: #dddddd;
}
.blueBtn {
  background: rgba(23, 145, 255, 0.1) !important;
  color: #1791FF;
  border: 1px solid rgba(23, 145, 255, 0.7) !important;
}
.orangeBtn {
  background: rgba(255, 142, 59, 0.1) !important;
  color: #FF8E3B;
  border: 1px solid rgba(255, 142, 59, 0.7) !important;
}
.greenBtn {
  background: rgba(54, 191, 125, 0.1) !important;
  color: #36BF7D;
  border: 1px solid rgba(54, 191, 125, 0.7) !important;
}
/deep/.ant-table-align-center {
  padding: 0 !important;
}
/deep/.ant-table-body-max-height-0 {
}
.dataAndPagin {
  display: flex;
  justify-content: space-between;
  margin-top: 6px;
  margin-bottom: 10px;
  .selectedDataDiv {
    display: flex;
    justify-content: space-between;
    width: 410px;
    .dataDiv {
      display: flex;
      margin-right: 12px;
      background-color: #E7F4FF;
      border-top: 1px solid #DDDDDD;
      border-bottom: 1px solid #DDDDDD;
      border-right: 1px solid #DDDDDD;
      .numDiv {
        border-left: 1px solid #DDDDDD;
        width: 120px;
        display: flex;
        align-items: center;
        padding: 6px 10px;
        font-weight: bold;
        box-sizing: content-box;
      }
    }
  }
}
.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 4px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 3px 3px 8px 0 rgba(0, 0, 0, 0.3);
  width: 120px;
  text-align: center;
}

.contextmenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}

.contextmenu li:hover {
  background: rgba(231, 244, 255, 1);
}
#assetTable {
  /deep/.ant-table-fixed-right {
    height: calc(100% - 50px);
    .ant-table-body-outer {
      height: calc(100% - 36px);
      .ant-table-body-inner {
        overflow: hidden scroll;
      }
    }
  }
  /deep/.ant-table-fixed-left {
    height: calc(100% - 50px);
    .ant-table-header {
      //border-left: 0.8px solid rgba(185, 222, 255, 1);
    }
    .ant-table-fixed {
      border-left: 0.8px solid rgba(185, 222, 255, 1);
      border-bottom: 0.8px solid rgba(185, 222, 255, 1) !important;
    }
    .ant-table-body-outer {
      height: calc(100% - 36px);
      .ant-table-body-inner {
        overflow: hidden scroll;
      }
    }
  }
}
.padding-1-8 {
  padding: 1px 8px !important;
}
.xuIcon {
  margin-right: 5px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(23,145,255,0.7);
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 3px;
  color: #1791FF;
}
.daiIcon {
  margin-right: 5px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(231, 59, 59, 0.50);
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 3px;
  color: rgba(231, 59, 59, 1);
}
.redIcon {
  margin-right: 5px;
  background-color: #E73B3B1A;
  border: 1px solid rgba(231, 59, 59, 0.7);
  font-size: 12px;
  padding: 3px 5px;
  border-radius: 3px;
  color: #E73B3B;
}
.orgIcon {
  margin-right: 5px;
  background: rgba(255,142,59,0.1);
  border: 1px solid rgba(255,142,59,0.7);
  font-size: 12px;
  padding: 3px 5px;
  border-radius: 3px;
  color: #FF8E3B;
}
.blueIcon {
  margin-right: 5px;
  //background: rgba(23,145,255,0.1);
  border: 1px solid rgba(221, 221, 221, 1);
  font-size: 12px;
  padding: 3px 5px;
  border-radius: 3px;
  color: rgba(23, 145, 255, 1);
}
/deep/.table-draggable-handle {
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
/deep/.resize-table-th {
  position: relative;
}
/deep/.ant-table-column-sorter-inner-full {
  margin-top: -0.5em !important;
}
</style>
